import { CardConfig } from './Home.types';
import CandidatesDisabled from './icons/candidates-disabled.png';
import Candidates from './icons/candidates.png';
import DashboardDisabled from './icons/dashboard-disabled.png';
import Dashboard from './icons/dashboard.png';
import EmployeesDisabled from './icons/employees-disabled.png';
import Employees from './icons/employees.png';
import Hra from './icons/hra.png';
import Nom035Disabled from './icons/nom035-disabled.png';
import Nom035 from './icons/nom035.png';
import UsersDisabled from './icons/users-disabled.png';
import Users from './icons/users.png';
import Worker from './icons/worker.png';

export const cardsConfig: CardConfig[] = [
	{
		id: 'dashboard',
		img: { enabled: Dashboard, disabled: DashboardDisabled },
		title: 'home.dashboard.title',
		text: 'home.dashboard.text',
		path: '/dashboard',
	},
	{
		id: 'employees',
		img: { enabled: Employees, disabled: EmployeesDisabled },
		title: 'home.employees.title',
		text: 'home.employees.text',
		path: '/employees',
	},
	{
		id: 'candidates',
		img: { enabled: Candidates, disabled: CandidatesDisabled },
		title: 'home.candidates.title',
		text: 'home.candidates.text',
		path: '/candidates',
	},
	{
		id: 'nom035',
		img: { enabled: Nom035, disabled: Nom035Disabled },
		title: 'home.nom035.title',
		text: 'home.nom035.text',
		path: '/campaigns',
	},
	{
		id: 'hra',
		img: { enabled: Hra, disabled: '' },
		title: 'home.hra.title',
		text: 'home.hra.text',
		path: '/health-risk-assessment',
	},
	{
		id: 'jobProfiles',
		img: { enabled: Worker, disabled: '' },
		title: 'home.jobProfiles.title',
		text: 'home.jobProfiles.text',
		path: '/job-profile',
	},
	{
		id: 'users',
		img: { enabled: Users, disabled: UsersDisabled },
		title: 'home.users.title',
		text: 'home.users.text',
		path: '/users',
	},
];
